import { render, staticRenderFns } from "./EditBankInstallmentDialog.vue?vue&type=template&id=8967956a"
import script from "./EditBankInstallmentDialog.vue?vue&type=script&lang=js"
export * from "./EditBankInstallmentDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBankInstallmentDialog.vue?vue&type=style&index=0&id=8967956a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports